import PreviewTextEditor from './PreviewTextEditor';

export default PreviewTextEditor;
